import i18n from 'i18n-js';

export const CATEGORIES_AVAILABLES = [
  'americanfootball',
  'basketball',
  'baseball',
  'coinflip',
  'confetti',
  'countdown',
  'countup',
  'medialoop',
  'padel',
  'roulette',
  'soccer',
];

export const getActions = () => ({
  americanfootball: [
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-play.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.play'),
      value: 'americanfootball-play',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-pause.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.pause'),
      value: 'americanfootball-pause',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-adddown.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.subtract1Down'),
      value: 'americanfootball-adddown',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-subtractdown.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.subtract1Down'),
      value: 'americanfootball-subtractdown',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-adddistance.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.add1Distance'),
      value: 'americanfootball-adddistance',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-subtractdistance.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.subtract1Distance'),
      value: 'americanfootball-subtractdistance',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-addpointlocal.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.add1PointLocal'),
      value: 'americanfootball-addpointlocal',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-subtractpointlocal.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.subtract1PointLocal'),
      value: 'americanfootball-subtractpointlocal',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-setpossessionlocal.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.setPossessionLocal'),
      value: 'americanfootball-setpossessionlocal',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-subtracttimeoutlocal.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.subtract1TimeoutLocal'),
      value: 'americanfootball-subtracttimeoutlocal',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-resettimeoutlocal.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.resetTimeoutsLocal'),
      value: 'americanfootball-resettimeoutlocal',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-addpointvisiting.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.add1PointVisiting'),
      value: 'americanfootball-addpointvisiting',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-subtractpointvisiting.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.subtract1PointVisiting'),
      value: 'americanfootball-subtractpointvisiting',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-setpossessionvisiting.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.setPossessionVisiting'),
      value: 'americanfootball-setpossessionvisiting',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-subtracttimeoutvisiting.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.subtract1TimeoutVisiting'),
      value: 'americanfootball-subtracttimeoutvisiting',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-resettimeoutvisiting.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.resetTimeoutsVisiting'),
      value: 'americanfootball-resettimeoutvisiting',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-addquarter.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.add1Quarter'),
      value: 'americanfootball-addquarter',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-subtractquarter.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.subtract1Quarter'),
      value: 'americanfootball-subtractquarter',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/americanfootball-reset.png',
      label: i18n.t('screens.builder.build.americanfootball.actions.reset'),
      value: 'americanfootball-reset',
    },
  ],
  basketball: [
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-play.png',
      label: i18n.t('screens.builder.build.basketball.actions.play'),
      value: 'basketball-play',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-pause.png',
      label: i18n.t('screens.builder.build.basketball.actions.pause'),
      value: 'basketball-pause',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-add1local.png',
      label: i18n.t('screens.builder.build.basketball.actions.add1PointLocal'),
      value: 'basketball-add1local',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-add2local.png',
      label: i18n.t('screens.builder.build.basketball.actions.add2PointLocal'),
      value: 'basketball-add2local',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-add3local.png',
      label: i18n.t('screens.builder.build.basketball.actions.add3PointLocal'),
      value: 'basketball-add3local',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-subtract1local.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.subtract1PointLocal'
      ),
      value: 'basketball-subtract1local',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-addFaultLocal.png',
      label: i18n.t('screens.builder.build.basketball.actions.add1FaultLocal'),
      value: 'basketball-addfaultlocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-subtractFaultLocal.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.subtract1FaultLocal'
      ),
      value: 'basketball-subtractfaultlocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-resetFaultsLocal.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.resetFaultsLocal'
      ),
      value: 'basketball-resetfaultslocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-add1visiting.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.add1PointVisiting'
      ),
      value: 'basketball-add1visiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-add2visiting.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.add2PointVisiting'
      ),
      value: 'basketball-add2visiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-add3visiting.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.add3PointVisiting'
      ),
      value: 'basketball-add3visiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-subtract1visiting.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.subtract1PointVisiting'
      ),
      value: 'basketball-subtract1visiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-addFaultVisiting.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.add1FaultVisiting'
      ),
      value: 'basketball-addfaultvisiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-subtractFaultVisiting.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.subtract1FaultVisiting'
      ),
      value: 'basketball-subtractfaultvisiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-resetFaultsVisiting.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.resetFaultsVisiting'
      ),
      value: 'basketball-resetfaultsvisiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-addquarter.png',
      label: i18n.t('screens.builder.build.basketball.actions.add1Quarter'),
      value: 'basketball-addquarter',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-subtractquarter.png',
      label: i18n.t(
        'screens.builder.build.basketball.actions.subtract1Quarter'
      ),
      value: 'basketball-subtractquarter',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-reset.png',
      label: i18n.t('screens.builder.build.basketball.actions.reset'),
      value: 'basketball-reset',
    },
  ],
  baseball: [
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-addpointlocal.png',
      label: i18n.t('screens.builder.build.baseball.actions.add1PointLocal'),
      value: 'baseball-addpointlocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-subtractpointlocal.png',
      label: i18n.t(
        'screens.builder.build.baseball.actions.subtract1PointLocal'
      ),
      value: 'baseball-subtractpointlocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-addpointvisiting.png',
      label: i18n.t('screens.builder.build.baseball.actions.add1PointVisiting'),
      value: 'baseball-addpointvisiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-subtractpointvisiting.png',
      label: i18n.t(
        'screens.builder.build.baseball.actions.subtract1PointVisiting'
      ),
      value: 'baseball-subtractpointvisiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-addinning.png',
      label: i18n.t('screens.builder.build.baseball.actions.add1Inning'),
      value: 'baseball-addinning',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-subtractinning.png',
      label: i18n.t('screens.builder.build.baseball.actions.subtract1Inning'),
      value: 'baseball-subtractinning',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-toggleinning.png',
      label: i18n.t('screens.builder.build.baseball.actions.toggleInningHalf'),
      value: 'baseball-toggleinning',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-toggle1base.png',
      label: i18n.t('screens.builder.build.baseball.actions.toggleRunner1base'),
      value: 'baseball-toggle1base',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-toggle2base.png',
      label: i18n.t('screens.builder.build.baseball.actions.toggleRunner2base'),
      value: 'baseball-toggle2base',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-toggle3base.png',
      label: i18n.t('screens.builder.build.baseball.actions.toggleRunner3base'),
      value: 'baseball-toggle3base',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-addout.png',
      label: i18n.t('screens.builder.build.baseball.actions.add1Out'),
      value: 'baseball-addout',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-subtractout.png',
      label: i18n.t('screens.builder.build.baseball.actions.subtract1Out'),
      value: 'baseball-subtractout',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-resetouts.png',
      label: i18n.t('screens.builder.build.baseball.actions.resetOuts'),
      value: 'baseball-resetouts',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-addball.png',
      label: i18n.t('screens.builder.build.baseball.actions.add1Ball'),
      value: 'baseball-addball',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-subtractball.png',
      label: i18n.t('screens.builder.build.baseball.actions.subtract1Ball'),
      value: 'baseball-subtractball',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-resetballs.png',
      label: i18n.t('screens.builder.build.baseball.actions.resetBalls'),
      value: 'baseball-resetballs',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-addstrike.png',
      label: i18n.t('screens.builder.build.baseball.actions.add1Strike'),
      value: 'baseball-addstrike',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-subtractstrike.png',
      label: i18n.t('screens.builder.build.baseball.actions.subtract1Strikes'),
      value: 'baseball-subtractstrike',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-resetstrikes.png',
      label: i18n.t('screens.builder.build.baseball.actions.resetStrikes'),
      value: 'baseball-resetstrikes',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-reset.png',
      label: i18n.t('screens.builder.build.baseball.actions.reset'),
      value: 'baseball-reset',
    },
  ],
  coinflip: [
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/coinflip-flip.png',
      label: i18n.t('screens.builder.build.coinflip.flip'),
      value: 'coinflip-flip',
    },
  ],
  confetti: [
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/confetti-start.png',
      label: i18n.t('screens.builder.build.confetti.actions.start'),
      value: 'confetti-start',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/confetti-stop.png',
      label: i18n.t('screens.builder.build.confetti.actions.stop'),
      value: 'confetti-stop',
    },
  ],
  countdown: [
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-play.png',
      label: i18n.t('screens.builder.build.countdown.actions.play'),
      value: 'countdown-play',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-pause.png',
      label: i18n.t('screens.builder.build.countdown.actions.pause'),
      value: 'countdown-pause',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-add1.png',
      label: i18n.t('screens.builder.build.countdown.actions.add1'),
      value: 'countdown-add1',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-add5.png',
      label: i18n.t('screens.builder.build.countdown.actions.add5'),
      value: 'countdown-add5',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-add10.png',
      label: i18n.t('screens.builder.build.countdown.actions.add10'),
      value: 'countdown-add10',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-reset.png',
      label: i18n.t('screens.builder.build.countdown.actions.reset'),
      value: 'countdown-reset',
    },
  ],
  countup: [
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countup-play.png',
      label: i18n.t('screens.builder.build.countup.actions.play'),
      value: 'countup-play',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countup-pause.png',
      label: i18n.t('screens.builder.build.countup.actions.pause'),
      value: 'countup-pause',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countup-add1.png',
      label: i18n.t('screens.builder.build.countup.actions.add1'),
      value: 'countup-add1',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countup-add5.png',
      label: i18n.t('screens.builder.build.countup.actions.add5'),
      value: 'countup-add5',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countup-add10.png',
      label: i18n.t('screens.builder.build.countup.actions.add10'),
      value: 'countup-add10',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/countup-reset.png',
      label: i18n.t('screens.builder.build.countup.actions.reset'),
      value: 'countup-reset',
    },
  ],
  medialoop: [
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-previousfile.png',
      label: i18n.t('screens.builder.build.medialoop.previousFile'),
      value: 'medialoop-previousfile',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-nextfile.png',
      label: i18n.t('screens.builder.build.medialoop.nextFile'),
      value: 'medialoop-nextfile',
    },
  ],
  padel: [
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-addpointlocal.png',
      label: i18n.t('screens.builder.build.padel.actions.addPointLocal'),
      value: 'padel-addpointlocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-subtractpointlocal.png',
      label: i18n.t('screens.builder.build.padel.actions.subtractPointLocal'),
      value: 'padel-subtractpointlocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-addpointvisiting.png',
      label: i18n.t('screens.builder.build.padel.actions.addPointVisiting'),
      value: 'padel-addpointvisiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-subtractpointvisiting.png',
      label: i18n.t(
        'screens.builder.build.padel.actions.subtractPointVisiting'
      ),
      value: 'padel-subtractpointvisiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-setServeLocalP1.png',
      label: i18n.t('screens.builder.build.padel.actions.setServeLocalP1'),
      value: 'padel-setServeLocalP1',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-setServeLocalP2.png',
      label: i18n.t('screens.builder.build.padel.actions.setServeLocalP2'),
      value: 'padel-setServeLocalP2',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-setServeAwayP1.png',
      label: i18n.t('screens.builder.build.padel.actions.setServeAwayP1'),
      value: 'padel-setServeAwayP1',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-setServeAwayP2.png',
      label: i18n.t('screens.builder.build.padel.actions.setServeAwayP2'),
      value: 'padel-setServeAwayP2',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/padel-reset.png',
      label: i18n.t('screens.builder.build.padel.actions.reset'),
      value: 'padel-reset',
    },
  ],
  roulette: [
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-spin.png',
      label: i18n.t('screens.builder.build.roulette.spinning'),
      value: 'roulette-spin',
    },
  ],
  soccer: [
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-play.png',
      label: i18n.t('screens.builder.build.soccer.actions.play'),
      value: 'soccer-play',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-pause.png',
      label: i18n.t('screens.builder.build.soccer.actions.pause'),
      value: 'soccer-pause',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-addgoallocal.png',
      label: i18n.t('screens.builder.build.soccer.actions.addGoalLocal'),
      value: 'soccer-addgoallocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-subtractgoallocal.png',
      label: i18n.t('screens.builder.build.soccer.actions.subtractGoalLocal'),
      value: 'soccer-subtractgoallocal',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-addgoalvisiting.png',
      label: i18n.t('screens.builder.build.soccer.actions.addGoalVisiting'),
      value: 'soccer-addgoalvisiting',
    },
    {
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-subtractgoalvisiting.png',
      label: i18n.t(
        'screens.builder.build.soccer.actions.subtractGoalVisiting'
      ),
      value: 'soccer-subtractgoalvisiting',
    },
    {
      image: 'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-reset.png',
      label: i18n.t('screens.builder.build.soccer.actions.reset'),
      value: 'soccer-reset',
    },
  ],
});

const streamdeck = {
  CATEGORIES_AVAILABLES,
  getActions,
};

export default streamdeck;
